import { Typography } from '@material-ui/core';
import { LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import moment from 'moment-timezone';
import React, { useMemo } from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { talentService } from 'shared/services/talentService';
import { Avatar, Message, MessageWrapper } from './Messaging.styles';
import { IMessage, IMessagePayload } from 'shared/interfaces/ITalent';
import { NO_PROFILE_IMAGE_PLACEHOLDER_URL } from 'shared/constants/ASSETS_URL';

interface Props {
  message: IMessage;
  me?: boolean;
}

const { getSenderDetails } = talentService();

const MessageItem: React.FC<Props> = ({ message, me }) => {
  const { data, isLoading } = getSenderDetails(message.sender, message.type);

  const parsedMessage = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return {
        avatar: data?.data.avatar,
        senderName: data?.data.name,
        note: message.note,
        timestamp: message.timestamp,
        id: message.id,
      };
    }
  }, [data, isLoading, message]);

  return parsedMessage ? (
    <Message>
      <Avatar src={parsedMessage.avatar ? parsedMessage.avatar : NO_PROFILE_IMAGE_PLACEHOLDER_URL} />
      <MessageWrapper>
        <Typography style={{ textTransform: 'capitalize', color: me ? COLORS.WARNING : COLORS.PRIMARY }}>
          {me ? 'You' : parsedMessage.senderName}
        </Typography>
        <Typography style={{ fontSize: 13, color: 'darkgray' }}>
          {moment(parsedMessage.timestamp).format('DD MMMM YYYY - hh:mmA')}
        </Typography>
        <Typography
          style={{
            fontSize: 14,
            whiteSpace: 'break-spaces',
          }}
        >
          {parsedMessage.note}
        </Typography>
      </MessageWrapper>
    </Message>
  ) : (
    <Message>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <LoadingSpinnerIconTwoTone style={{ width: 55, height: 55, alignSelf: 'center' }} />
      </div>
    </Message>
  );
};

export default MessageItem;
